import { ReactNode, useState, useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { Button } from "@/components/ui/button";
import { MessageSquare, ArrowUp } from "lucide-react";
import MessageDialog from "./MessageDialog";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  // 监听滚动事件，控制回到顶部按钮显示
  useEffect(() => {
    const handleScroll = () => {
      // 当滚动超过 300px 时显示按钮
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setShowBackToTop(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 回到顶部
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      
      {/* Back to Top Button */}
      {showBackToTop && (
        <Button
          onClick={scrollToTop}
          className="fixed bottom-24 right-8 z-50 rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 bg-gray-800 hover:bg-gray-700"
          size="lg"
          title="回到顶部"
        >
          <ArrowUp className="w-5 h-5" />
        </Button>
      )}
      
      {/* Floating Message Button */}
      <Button
        onClick={() => setIsMessageDialogOpen(true)}
        className="fixed bottom-8 right-8 z-50 rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300"
        size="lg"
      >
        <MessageSquare className="w-6 h-6" />
      </Button>
      
      {/* Message Dialog */}
      <MessageDialog
        isOpen={isMessageDialogOpen}
        onClose={() => setIsMessageDialogOpen(false)}
      />
    </div>
  );
};

export default Layout;